import React from 'react';
import { Typography, Link } from '@nextiva/next-ui-components';
import useModal from '../hooks/useSchedulesModalState';
import Modal from './ScheduleDescriptionModal';

const PageHeading = () => {
  const { isModalOpen, openModal, closeModal } = useModal();

  return (
    <>
      <Typography variant="body1">
        These schedules are created by an administrator and available to all
        users within your company. Learn about other
        <Link
          variant="body1"
          href="/"
          onClick={openModal}
          data-testid="PlatformAdminUI-Schedules-TypeOfSchedules-ModalButton"
          sx={{
            margin: '0 0 0 8px',
            textDecoration: 'underline',
          }}
        >
          types of schedules
        </Link>
        .
      </Typography>
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default PageHeading;
